import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ReferralProductService {


  constructor(private http: HttpClient) { }
  url = environment.serverAPI4 + '/' + 'api/referral/product';

  url5 = environment.serverAPI + "/api/auth";

  searchProduct(query, Page: any, size: any, sort: any): Observable<Object> {
		return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
	}

  getProducts(Page: any, size: any, sort: any): Observable<Object> {
		return this.http.get(`${this.url}/solr?page=${Page}&size=${size}&sort=${sort}`);
	}

  getProductBySearch(query, Page: any, size: any, sort: any): Observable<Object> {
		return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
	}

  getReferalId(): Observable<Object> {

    return this.http.get(`${this.url5}/referral/id`);

  }


}
